export const mutations = {
  addCargoEntry(state) {
    state.cargos.push({
      container_no: "",
      cargo_size: "",
      weight_units: "",
      net_weight: ""
    });
  },
  STORE_CARGOS(state, cargoentries) {
    state.cargoentries = cargoentries;
  },

  STORE_FILEOPENING(state, fileopeningcargos) {
    state.fileopeningcargos = fileopeningcargos;
  },

  STORE_CARGO_UPDATE(state, cargoId) {
    let Cargo = state.cargoentries.find(function(cargoentry) {
      return cargoentry.id === cargoId;
    });
    state.systemCargo = Cargo;
  },
  STORE_CARGOS_UPDATE(state, fileopeningId) {
    let Cargofile = state.fileopeningcargos.find(function(fileopeningcargo) {
      return fileopeningcargo.id === fileopeningId;
    });
    state.systemCargofile = Cargofile;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/cargoentries/mutations.js